<style scoped lang="scss">
   .file-dropzone {
        border: none;
        text-align: center;
    }
    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
        padding: 0;
        margin: 0;
        min-height: inherit;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dropzone-custom-title {
            margin: 0;
        }
    }
    .file-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .a-file-search {
        font-size: 20px;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1 uk-margin-bottom">
            <legend>{{ __('tenant.inc_other_program_letter', {letter: letter}) }}</legend>
        </div>

        <div class="uk-width-small-1-1 ">
            <h3>{{ __('tenant.inc_proof_of_letter', {year: application.tax_year}) }}</h3>
            <validated-section :field="`has_record_${member.id}`" :errors="errors">
            </validated-section>
            <table class="uk-table uk-table-striped uk-width-1-1 uk-hidden-small">
                <thead>
                <tr>
                    <th>{{ __('tenant.inc_documentation') }}</th>
                    <th>{{ __('tenant.inc_gross_amount_earned') }}</th>
                    <th>{{ __('tenant.inc_upload_file') }}</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(income, idx) in incomes">
                    <td>
                        {{ __('tenant.inc_eligibility_letter') }}
                    </td>
                    <td>
                        <validated-section :errors="errors" :field="`income_amount_${idx}`">
                            <vue-numeric currency="$" v-model="income.income_amount" @change.native="onInputChanged" type="text" class="uk-form-large uk-input uk-width-1-1"/>
                        </validated-section>
                    </td>
                    <td>
                        <div v-if="income.documents.length" class="uk-margin-bottom file-wrapper">
                            <div class="icon-container">
                                <a href="javascript:;" @click="previewFile(income.documents[0])">
                                    <i class="uk-icon-medium a-file-search"></i><br>
                                    <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                                </a>
                            </div>
                            <a :href="`documents/download/${income.documents[0].id}`" target="_blank"><span class="uk-margin-left">{{income.documents[0].filename}}</span></a>
                            <a href="javascript:;" uk-tooltip title="Delete File" class="uk-margin-left uk-text-danger" @click="deleteDocument(idx, income.documents[0])" style="font-size: 20px;"><i class="fa fa-times"></i></a>
                        </div>
                        <div v-else>
                            <validated-section :errors="errors" :field="`document_${idx}`">
                                <div>
                                    <vue-dropzone
                                        :ref="`dropzoneUpload_${idx}`"
                                        :options="dropzoneOptions"
                                        :useCustomSlot=true
                                        v-on:vdropzone-sending="sendingFile"
                                        v-on:vdropzone-success="onFileUpdated(idx)"
                                        v-on:vdropzone-file-added="onFileAdded(income)"
                                    >
                                      <div class="dropzone-custom-content file-dropzone">
                                        <p class="dropzone-custom-title">{{ __('tenant.inc_drop_file') }}</p>
                                      </div>
                                    </vue-dropzone>
                                </div>
                            </validated-section>
                        </div>
                    </td>

                    <td style="padding-top: 18px;">
                        <i class="a-trash-2 uk-text-danger" style="cursor: pointer; font-size: 1.4em;" @click="removeIncome(idx)"></i>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked" v-for="(income, idx) in incomes">
                <div class="uk-width-1-1">
                    <h4>{{ income.label }}</h4>
                </div>
                <div class="uk-width-1-1 uk-margin-top uk-margin-bottom">
                    <h4>{{ __('tenant.inc_document_type') }}</h4>
                    <validated-section :errors="errors" :field="`type_${idx}`">
                        <select v-model="income.type" class="uk-input uk-form-large uk-width-1-1" :required="required">
                            <option :value="null">Select a Type...</option>
                            <option :value="item.id" v-for="item in incomeTypes">{{ item.label }}</option>
                        </select>
                    </validated-section>
                </div>
                <div class="uk-width-1-1 uk-margin-top uk-margin-bottom">
                    <h4>{{ __('tenant.inc_gross_amount_earned') }}</h4>
                    <validated-section :errors="errors" :field="`income_amount_${idx}`">
                        <vue-numeric currency="$" v-model="income.income_amount" @change.native="onInputChanged" type="text" class="uk-form-large uk-input uk-width-1-1"/>
                    </validated-section>
                </div>
                <div class="uk-width-1-1 uk-margin-top uk-margin-bottom">
                    <div v-if="income.documents.length" class="uk-margin-bottom file-wrapper">
                        <div class="icon-container">
                            <a href="javascript:;" @click="previewFile(income.documents[0])">
                                <i class="uk-icon-medium a-file-search"></i><br>
                                <span style="font-size: 0.8em;">{{ __('global.preview') }}</span>
                            </a>
                        </div>
                        <a :href="`documents/download/${income.documents[0].id}`" target="_blank"><span class="uk-margin-left">{{income.documents[0].filename}}</span></a>
                        <a href="javascript:;" uk-tooltip title="Delete File" class="uk-margin-left uk-text-danger" @click="deleteDocument(idx, income.documents[0])" style="font-size: 20px;"><i class="fa fa-times"></i></a>
                    </div>
                    <div v-else>
                        <validated-section :errors="errors" :field="`document_${idx}`">
                            <div>
                                <vue-dropzone
                                    :ref="`dropzoneUpload_${idx}_mobile`"
                                    :options="dropzoneOptions"
                                    :useCustomSlot=true
                                    v-on:vdropzone-sending="sendingFile"
                                    v-on:vdropzone-success="onFileUpdated(idx, 'mobile')"
                                    v-on:vdropzone-file-added="onFileAdded(income)"
                                >
                                  <div class="dropzone-custom-content file-dropzone">
                                    <p class="dropzone-custom-title">{{ __('tenant.inc_drop_file') }}</p>
                                  </div>
                                </vue-dropzone>
                            </div>
                        </validated-section>
                    </div>
                    <div class="uk-width-1-1 uk-margin-top uk-margin-bottom uk-text-right">
                        <a href="javascript:;" class="uk-button uk-button-danger" @click="removeIncome(idx)"><i class="a-trash-2"></i>  {{ __('tenant.inc_delete_item') }}</a>
                    </div>
                    <hr/>
                </div>
            </div>
            <div class="uk-width-1-1  uk-text-right">
                <button class="uk-button uk-button-primary" @click="addIncome">
                    <i class="a-circle-plus"></i>
                    {{ __('tenant.inc_add_documentation_for_member', {name: member.first_name + ' ' + member.last_name}) }}
                </button>
            </div>
        </div>
        <preview-document-modal ref="previewModal"></preview-document-modal>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ValidatedSection from "../../../../../../components/Common/ValidatedSection";
    import PreviewDocumentModal from "../../../../../../../dashboard/pages/Documents/PreviewDocumentModal";

    export default {
        name: "W2Or1099EntryForm",
        components: {
            vueDropzone: vue2Dropzone,
            ValidatedSection,
            PreviewDocumentModal
        },
        props: ['label', 'member', 'values', 'url'],
        data() {
            return {
                errors: {},
                incomeTypes: [
                    {'id': 'w2', 'label': 'Form W2'},
                    {'id': 'k1', 'label': 'Form K-1'},
                    {'id': '1099-A', 'label': 'Form 1099-A'},
                    {'id': '1099-B', 'label': 'Form 1099-B'},
                    {'id': '1099-C', 'label': 'Form 1099-C'},
                    {'id': '1099-CAP', 'label': 'Form 1099-CAP'},
                    {'id': '1099-DIV', 'label': 'Form 1099-DIV'},
                    {'id': '1099-G', 'label': 'Form 1099-G'},
                    {'id': '1099-INT', 'label': 'Form 1099-INT'},
                    {'id': '1099-K', 'label': 'Form 1099-K'},
                    {'id': '1099-LTC', 'label': 'Form 1099-LTC'},
                    {'id': '1099-MISC', 'label': 'Form 1099-MISC'},
                    {'id': '1099-OID', 'label': 'Form 1099-OID'},
                    {'id': '1099-PATR', 'label': 'Form 1099-PATR'},
                    {'id': '1099-Q', 'label': 'Form 1099-Q'},
                    {'id': '1099-R', 'label': 'Form 1099-R'},
                    {'id': '1099-SA', 'label': 'Form 1099-SA'},
                ],
                incomes: [],
                dropzoneOptions: {
                    url: this.url,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    maxFiles: 1,
                },
                sendingFileType: null,
            }
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
        },
        mounted() {
            const incomeTypeIds = this.incomeTypes.map(item => item.id)
            if (this.member.incomes && this.member.incomes.length)
            {
                const filteredIncomes = this.member.incomes.filter(item => incomeTypeIds.includes(item.type))
                this.incomes = filteredIncomes
            }
        },
        methods: {
            previewFile(document) {
                let url =`/api/hope/documents/${document.id}/preview`;
                this.$refs.previewModal.open(url, document);
            },

            onFileAdded(income)
            {
                this.sendingFileType = income.type
            },

            sendingFile(file, xhr, formData) {
                formData.append('application_id', this.application.id);
                formData.append('household_member_id', this.member.id);
                formData.append('type', this.sendingFileType);
            },

            addIncome() {
                this.incomes.push({
                    id: null,
                    type: 'eligibility_letter',
                    income_amount: 0,
                    documents: [],
                })
            },
            removeIncome(idx) {
                this.incomes.splice(idx, 1);
            },

            _getDocumentIdsFromOrgFiles(files) {
                if (files && files.length)
                {
                    const res = JSON.parse(files[0].xhr.response);
                    return [res.document]
                }
                return []
            },

            getDocuments(index, type) {
                let ref = this.$refs[`dropzoneUpload_${index}`][0]
                if (type === 'mobile')
                {
                    ref = this.$refs[`dropzoneUpload_${index}_mobile`][0]
                }
                const orgFiles = ref.getAcceptedFiles()
                return this._getDocumentIdsFromOrgFiles(orgFiles);
            },

            onFileUpdated(index, type = undefined) {
                this.incomes[index].documents = this.getDocuments(index, type);
            },

            deleteDocument(index, doc) {
                this.$store
                    .dispatch('Document/deleteDocument', doc.id)
                    .then((res) => {
                        this.incomes[index].documents = [];
                    })
                    .catch((err) => {
                    })
            },

            validate() {
                this.errors = {};
                let isValid = true;

                if (this.incomes && this.incomes.length === 0)
                {
                    this.errors[`has_record_${this.member.id}`] = { errors: [ "You must provide at least one document." ]}
                }

                _.each(this.incomes, (income, index) => {
                    if (!income.documents.length)
                    {
                        this.errors[`document_${index}`] = { errors: [ "You must provide a document." ]}
                    }
                    if (!income.income_amount)
                    {
                        this.errors[`income_amount_${index}`] = { errors: [ "Please input a value." ]}
                    }

                })

                let errorCount = _.size(this.errors);

                if(errorCount > 0) isValid = false;

                return isValid;
            },

            onInputChanged() {
                this.$emit('updated', {member: this.member, amounts: this.incomes});
            }
        }
    }
</script>
